<template>
  <div class="chat-message" :class="direction">
    <img class="message-avatar" :src="message.sender_image" alt="">
    <div :class="{ deleted }" class="message">
      <span class="message-author">
        <span v-if="$checkUserIsAdmin(message.user)">
          <template v-if="$vlastMode">
            {{ message.user.name }} (Admin)
          </template>
          <template v-else>
            {{ clientName }} Admin -  {{ message.user.first_name }}
          </template>
        </span>
        <span v-else>{{ message.user.name }}</span>
        <span v-if="message.user.role === 'manager'"> - Manager</span>
      </span>
      <br/>
      <span class="message-date">{{ messageLocalTime }}</span>

      <span class="message-content" v-if="message.text" >{{ message.text.trim() }}</span>

      <div v-if="message.type === 'file'" >
        <span v-if="message.file" class="message-filename" >{{ message.file.file_name | truncateFilename(20) }}</span>
        <span v-else >File Deleted</span>
      </div>

      <div class="actions">
        <span v-if="$userIsAdmin" class="message-sub pull-right">
          <i v-if="!this.message.deleted_at" class="fa fa-trash" title="Delete Message" @click="handleDeleteMessageCallback"></i>
          <i v-else-if="message.type !== 'file'" class="fa fa-refresh" title="Restore Message" @click="handleRestoreMessageCallback"></i>
        </span>

        <span v-if="message.type === 'file' && message.file" @click="this.handleDownloadFileCallback" class="message-download" >
          <i class="fa fa-cloud-download"></i> Download File
        </span>

        <div v-else-if="message.user_id === this.$user.id" class="pull-left">
          <span class="pull-right message-sub" v-if="this.message.loading">Sending<span class="loader"></span></span>
          <span class="pull-right message-sub" v-else>Sent</span>
        </div>

      </div>
    </div>

    <span v-for="reader in readers" :key="reader.id">
      <img class="message-avatar pull-right" style="width: 20px;" :src="reader.profile_image_url" alt="" :id="'reader' + reader.id">
      <tooltip :text="readerName(reader)" :target="'#reader' + reader.id"></tooltip>
    </span>
    <span v-if="readers.length" style="color: grey; font-size: 12px" class="pull-right">Seen by&nbsp;</span>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState, mapActions } from 'vuex'
import { DATE_FORMAT, DATE_FORMAT_US } from '../../mixins'
import { ChatTracker } from 'mixins/analytics'

export default {
  mixins: [ChatTracker],
  props: {
    message: {
      required: true,
      type: Object
    },
    readers: {
      required: true,
      type: Array
    }
  },

  filters: {
    truncateFilename (fullStr, strLen, separator) {
      if (fullStr.length <= strLen) return fullStr

      separator = separator || '...'

      const sepLen = separator.length
      const charsToShow = strLen - sepLen
      const frontChars = Math.ceil(charsToShow / 2)
      const backChars = Math.floor(charsToShow / 2)

      return fullStr.substr(0, frontChars) +
        separator +
        fullStr.substr(fullStr.length - backChars)
    }
  },

  computed: {
    ...mapState('message', ['thread']),

    direction () {
      if (this.message.user_id === this.$user.id) {
        return 'right'
      }
      return 'left'
    },

    deleted () {
      if (this.message.deleted_at) {
        return 'deleted'
      }
      return ''
    },

    messageLocalTime () {
      let format = DATE_FORMAT
      if (this.$user.date_format_preference && this.$user.date_format_preference === 'month-first') {
        format = DATE_FORMAT_US
      }
      return moment.utc(this.message.created_at).tz(this.$user.timezone).format(format + ' - h:mm a')
    }
  },

  methods: {
    ...mapActions('message', ['deleteMessage', 'restoreMessage']),
    ...mapActions('booking/file', ['downloadFile', 'removeFile']),

    handleDeleteMessageCallback () {
      const fileId = this.message.file && this.message.file.id ? this.message.file.id : null

      return this.deleteMessage({ threadId: this.thread.id, messageId: this.message.id }).then(response => {
        if (fileId) {
          this.removeFile({ fileId })
        }
        return response
      })
    },

    handleRestoreMessageCallback () {
      return this.restoreMessage({ threadId: this.thread.id, messageId: this.message.id })
    },

    handleDownloadFileCallback () {
      this.trackEvent(this.analytics.V2.ChatFileDownloadEvent, {
        'fileName': this.message.file ? this.message.file.file_name : null,
        'fileType': this.message.file ? this.message.file.file_type : null
      })
      return this.downloadFile({ id: this.message.booking_id, file: this.message.file })
    },

    readerName (reader) {
      if (this.$checkUserIsAdmin(reader)) {
        return this.clientName + ' Admin - ' + reader.name
      }
      return reader.name
    }
  }
}
</script>
